import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";

const {getAll, get} = $dom

const groupSelector = '.js-dropdown-group'

export default function () {
    const dropdownShow = () => {
        const dropdowns = getAll(groupSelector)

        dropdowns.forEach(item => {
            const dropdown_hover = get('.dropdown-hover', item)

            if (dropdown_hover) {
                $events.add('mouseenter', dropdown_hover, (e) => {
                    e.target.nextElementSibling.classList.add('visible')

                    $events.add('mouseleave', item, () => {
                        e.target.nextElementSibling.classList.remove('visible')
                    })
                })
            }
        })
    }

    return new Component({
        name: 'dropdown',
        requiredTargets: groupSelector,
        onInit() {
            dropdownShow()
        },
        onDestroy() {

        },
    })

};